import { POST } from './api'

export const GenerateQuestions = async (params) => {
    return await POST(`/generate-ai`, params, true);
}